export { default } from './use-get-settings'
